import {PaymentInstrument} from 'coreStore/data/orders/types';
import PaymentCardModel from './PaymentCardModel';

/**
 * Represents an order payment instrument
 */
class PaymentInstrumentModel {
	private readonly paymentInstrument: PaymentInstrument;
	private readonly paymentCard: PaymentCardModel;

	/**
	 * @constructor
	 * @param {PaymentInstrument} paymentInstrument - payment instrument
	 */
	constructor(paymentInstrument: PaymentInstrument) {
		this.paymentInstrument = paymentInstrument;

		if (this.paymentInstrument.paymentCard) {
			this.paymentCard = new PaymentCardModel(this.paymentInstrument.paymentCard);
		}
	}

	/**
	 * Returns payment instrument amount
	 * @returns {number} amount
	 */
	getAmount(): number {
		return this.paymentInstrument.amount;
	}

	/**
	 * Returns payment instrument id
	 * @returns {string} id
	 */
	getPaymentInstrumentId(): string {
		return this.paymentInstrument.paymentInstrumentId;
	}

	/**
	 * Returns payment instrument id
	 * @returns {string} id
	 */
	getPaymentMethodId(): string {
		return this.paymentInstrument.paymentMethodId;
	}

	/**
	 * Returns payment card
	 * @returns {PaymentCardModel|null} id
	 */
	getPaymentCard(): PaymentCardModel|null {
		return this.paymentCard || null;
	}

	/**
	 * Returns gift card Type
	 * @returns {string} id
	 */
	getGiftCardType(): string {
		return this.isGiftCertificate() ? this.paymentInstrument?.giftcardType || '' : '';
	}

	/**
	 * Checks if current payment instrument is gift certificate with storeCredit type
	 * @returns {boolean}
	 */
	isStoreCredit(): boolean {
		return this.getGiftCardType() === 'SC';
	}

	/**
	 * Checks if current payment instrument is gift certificate with giftCertificate type
	 * @returns {boolean}
	 */
	isGiftCertificateType(): boolean {
		return this.getGiftCardType() === 'GC';
	}

	/**
	 * Checks if current payment instrument is gift certificate
	 * @returns {boolean}
	 */
	isGiftCertificate(): boolean {
		return this.paymentInstrument.paymentMethodId === 'GIFT_CERTIFICATE';
	}
}

export default PaymentInstrumentModel;
